import fetchJSON from '../fetchJSON'

interface Thumbnail {
  alt: string;
  url: string;
}

interface Communication {
  id: number;
  channelId: number;
  date: string;
  presenter: string;
  description: string;
  thumbnail: Thumbnail;
  link: string;
  title: string;
  status: string;
  duration: number;
}

interface CloudSearchResponse {
  communications: Communication[];
}

export const defaultState = {
  communications: []
}

async function fetchCloudSearch(hostUrl = '') {

  let response

  try {

    response = await fetchJSON<CloudSearchResponse>('cloudSearch', `/webcast/api/webcasts`, { includeCredentials: true })
    return !response ? defaultState : response?.data

  }
  catch (e) {    

  }
}

export default fetchCloudSearch
